import CryptoJS from "crypto-js";
import { useCallback } from "react";
import shortHash from "short-hash";
import * as Sentry from "@sentry/react";
import { endpoints } from "@songtradr-one/shared-common";
import { Api } from "../../api/api";
import { useAppContext } from "../../context/app-context/AppContext";
import { ReportActionParams } from "./useReportAction.Parts";

export const useReportAction = () => {
  const { user } = useAppContext();

  const reportAction = useCallback(
    async ({
      action,
      reference,
      referenceKey,
      memo,
      deduplicationKey,
      data,
    }: ReportActionParams) => {
      if (!user?.id) return;

      try {
        const payload = {
          action,
          reference,
          referenceKey,
          memo,
          data: { userId: user.id, ...data },
          deduplicationKey:
            deduplicationKey ?? shortHash(`${user.id}:${referenceKey}`),
        };

        // Encrypt the payload to disguise action
        const encrypted = CryptoJS.AES.encrypt(
          JSON.stringify(payload),
          user.id,
        ).toString();

        // Send encrypted payload
        await Api.post(endpoints.userActionLog.create, { ed: encrypted });
      } catch (err) {
        Sentry.captureException(err);
      }
    },
    [user],
  );

  return reportAction;
};
